import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Loader from "./Loader"; // Your loader component
import img from "../assets/images/log112.png";

export default function SubscribeModal({ isOpen, onClose }) {
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const API_BASE = process.env.REACT_APP_API_BASE;

  if (!isOpen) return null;

  const overlayStyle = {
    position: "fixed",
    top: 0, left: 0,
    width: "100%", height: "100%",
    backgroundColor: "rgba(0,0,0,0.55)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10000,
    padding: "10px",
    overflowY: "auto",
  };

  const modalStyle = {
    background: "#fff",
    width: "100%",
    maxWidth: "420px",
    padding: "25px",
    borderRadius: "8px",
    position: "relative",
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
    boxSizing: "border-box",
  };

  const closeBtnStyle = {
    position: "absolute",
    top: "12px",
    right: "12px",
    background: "transparent",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
  };

  const inputStyle = {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    color: "#000",
    padding: "10px",
    borderRadius: "4px",
    width: "100%",
    marginBottom: "12px",
  };

  const buttonStyle = {
    backgroundColor: "#1d2163",
    color: "#fff",
    padding: "10px",
    borderRadius: "4px",
    border: "none",
    width: "100%",
    cursor: "pointer",
    fontWeight: "bold",
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <button style={closeBtnStyle} onClick={onClose}>&times;</button>
        <img src={img} alt="ARO Events" style={{ width: "60px", marginBottom: "15px" }} />
        <h3 style={{ marginBottom: "8px" }}>Stay informed about all updates.</h3>
        <p style={{ fontSize: "14px", color: "#333", marginBottom: "15px" }}>
          Join the conference email list for all the latest event updates.
        </p>

        <Formik
          initialValues={{ email: "" }}
          validationSchema={Yup.object({
            email: Yup.string().email("Invalid email").required("Email is required"),
          })}
          onSubmit={async (values, { resetForm }) => {
            setLoading(true);
            setAlert(null);
            try {
              const res = await axios.post(`${API_BASE}/subscribe`, values);
              setAlert({ type: "success", message: res.data.message });
              resetForm();

              // Auto-close modal after 3 seconds
              setTimeout(() => {
                onClose();
                setAlert(null);
              }, 3000);

            } catch (err) {
              const msg = err.response?.data?.message || "Something went wrong. Please try again.";
              setAlert({ type: "danger", message: msg });
            } finally {
              setLoading(false);
            }
          }}
        >
          {() => (
            <Form>
              {loading && <Loader />}
              <Field type="email" name="email" placeholder="Email address *" style={inputStyle} />
              <ErrorMessage name="email" component="div" style={{ color: "red", fontSize: "12px", marginBottom: "10px" }} />

              <button type="submit" style={buttonStyle} disabled={loading}>
                {loading ? "Signing up..." : "Sign Up"}
              </button>

              {alert && (
                <div style={{ fontSize: "14px", marginTop: "12px", color: alert.type === "success" ? "green" : "red" }}>
                  {alert.message}
                </div>
              )}

              <p style={{ fontSize: "11px", color: "#555", marginTop: "15px", lineHeight: "1.5" }}>
                By proceeding, you're agreeing to receive communications from ARO Events Private Limited and/or its affiliates, in accordance with our <a href="/terms">Terms of Use</a> and <a href="/privacy">Privacy Policy</a>.
              </p>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
